import { atom, selector, DefaultValue } from "recoil"
import { ProductOverlayProps } from "./types"
import { ProductPageLocation } from "../../../constants/types"
import layoutStates from "../layout"

export const productOverlayAtom = atom<ProductOverlayProps>({
  key: "productOverlayAtom",
  default: {
    isOpen: false,
    productTitle: "",
    productDescription: "",
    variants: [],
    options: [],
    coverImages: [],
    selectedImages: [],
    selectedVariant: {},
    defaultImageSrc: "",
    currencySymbol: "",
    checkoutUrl: "",
    isProductDelete: false,
    isBadgeLiveMode: false,
    action: "",
    productImage: "",
    productCurrentPrice: "",
    productOldPrice: "",
    productButtonText: "",
    channel: ""
  }
})

export const productOverlaySelector = selector<ProductOverlayProps>({
  key: "productOverlaySelector",
  get: ({ get }) => get(productOverlayAtom),
  set: ({ get, set, reset }, productOverlayParam) => {
    if (productOverlayParam instanceof DefaultValue) return false

    const { action } = productOverlayParam as ProductOverlayProps

    if (action === "reset") {
      reset(productOverlayAtom)
    } else {
      set(productOverlayAtom, prevItem => ({
        ...prevItem,
        ...productOverlayParam
      }))
    }
  }
})


export const productPageOverlayURLAtom = atom({
  key: "productPageOverlayURLAtom",
  default: ""
})

export const locationOfProductPageAtom = atom<ProductPageLocation>({
  key: "locationOfProductPageAtom",
  default: null
})

export const productPageOverlaySelector = selector<{
  url: string
  isOpen?: boolean
  location?: ProductPageLocation
}>({
  key: "productPageOverlaySelector",
  get: ({ get }) => {
    return {
      isOpen: get(layoutStates.isFloatingDivActive),
      url: get(productPageOverlayURLAtom),
      location: get(locationOfProductPageAtom)
    }
  },
  set: ({ set }, payload) => {
    if (payload instanceof DefaultValue) return

    const { url, isOpen, location } = payload
    set(productPageOverlayURLAtom, url)
    set(locationOfProductPageAtom, location)
    set(layoutStates.isFloatingDivActive, isOpen === undefined ? !!url : isOpen)
  }
}) 
